import { RequirementsTable } from "../../../Requirements/components/RequirementsTable";
import { RequirementContextType } from "../../../Requirements/types";
import {
  IRequirementResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { useHistory, useRouteMatch } from "react-router-dom";
import { PATH_ONBOARDING_PAYEE } from "../../index";
import { PATH_EMBEDDED_ONBOARDING } from "../../../Embedded/paths";
import { useRequirementInstructionsModal } from "../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { selectorIsInstructionsModalAvailable } from "../../../Requirements/selectors/selectorIsInstructionsModalAvailable";

const getRequirementDetailsPath = (
  requirementId: string,
  isEmbedded: boolean
) =>
  isEmbedded
    ? `${PATH_EMBEDDED_ONBOARDING}/eligibility-requirements/${requirementId}`
    : `${PATH_ONBOARDING_PAYEE}/requirements/${requirementId}/details`;

export const PayerRequirements: React.FC<{
  requirements: IRequirementResponse[];
}> = props => {
  const history = useHistory();
  const requirementInstructionsModal = useRequirementInstructionsModal();
  const isEmbedded = !!useRouteMatch(PATH_EMBEDDED_ONBOARDING);

  return (
    <RequirementsTable
      requiredAction="Start"
      onViewDetails={async (requirement, additionalData) => {
        if (requirement.status !== RequirementStatus.Complete) {
          if (
            selectorIsInstructionsModalAvailable(requirement, additionalData)
          ) {
            const instructionsResult = await requirementInstructionsModal.open({
              requirementId: requirement.requirementId
            });

            if (instructionsResult !== true) return;
          }
        }

        history.push(
          getRequirementDetailsPath(requirement.requirementId, isEmbedded)
        );
      }}
      contextType={RequirementContextType.Payer}
      requirements={props.requirements}
    />
  );
};
